const Error = () => {
  const handleGoBack = () => {
    // Store current pathname to detect if navigation worked
    const currentPath = window.location.pathname;

    // Attempt to go back
    window.history.go(-1);

    // Check if we actually navigated after a short delay
    setTimeout(() => {
      if (window.location.pathname === currentPath) {
        // If still on same page, try going back 2 steps to skip prevented page
        window.history.go(-2);

        // If still blocked after another delay, try -3
        setTimeout(() => {
          if (window.location.pathname === currentPath) {
            window.history.go(-3);
          }
        }, 100);
      }
    }, 100);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-6">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md w-full text-center border border-gray-100">
        <h1 className="text-2xl md:text-3xl font-bold text-red-600 mb-4">
          No payment details seen
        </h1>

        <button
          onClick={handleGoBack}
          className="px-6 py-2 bg-primary text-white font-medium rounded-lg shadow hover:bg-[rgba(var(--primary-rgb),0.7)] transition duration-200"
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default Error;
